(function(global) {
    'use strict';

    global.Utils = new Utils();

    function Utils() {

    }

    Utils.prototype.addEventListener = function(type, parentElement, targetElement, callable) {
        parentElement.addEventListener(type, (e) => {
            this._addEventListenerDecorator(e, targetElement, callable);
        });
    };

    Utils.prototype._addEventListenerDecorator = function(e, target, callable) {
        if (!e.target.classList.contains(target)) {
            return;
        }

        return callable(e, e.target);
    };

    Utils.prototype.addEventListeners = function(type, parentElement, targetElementsSelector, callable) {
        var targetElements = parentElement.querySelectorAll(targetElementsSelector);
        if (!targetElements) {
            return;
        }

        [].forEach.call(targetElements, (targetElement) => {
            targetElement.addEventListener(type, callable);
        });
    };

})(window);